import React, { createContext, useContext, useEffect, useState } from "react";
import { log } from "@/lib/logger";

const RVCtx = createContext(null);
const KEY = "bhola_recent_v1";
const MAX = 8;

export const RecentlyViewedProvider = ({ children }) => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    try {
      const raw = localStorage.getItem(KEY);
      if (raw) setItems(JSON.parse(raw));
    } catch (err) {
      log.error("[RecentlyViewedContext] read failed", err);
    }
  }, []);
  const push = (item) => {
    setItems((cur) => {
      const next = [
        { tag_no: item.tag_no, item_name: item.item_name, image_path: item.image_path, karat: item.karat, gold_weight: item.gold_weight, diamond_weight: item.diamond_weight, mrp: item.mrp, collection: item.collection },
        ...cur.filter((i) => i.tag_no !== item.tag_no),
      ].slice(0, MAX);
      try { localStorage.setItem(KEY, JSON.stringify(next)); } catch (err) {
        log.error("[RecentlyViewedContext] write failed", err);
      }
      return next;
    });
  };
  return <RVCtx.Provider value={{ items, push }}>{children}</RVCtx.Provider>;
};
export const useRecentlyViewed = () => useContext(RVCtx);
